// extracted by mini-css-extract-plugin
export default {"nameSection":"BenefitCard_nameSection__6Bvqq","costSection":"BenefitCard_costSection__mYv5+","chevronSection":"BenefitCard_chevronSection__zU2f-"};